import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Alert, Button, Form, InputNumber, Modal } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { Storage } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getVirement, valideVirement } from './virement.reducer';
import axios from 'axios';
import CountUp from 'react-countup';
import { DashboardData } from 'app/shared/model/finance.model';

export const VirementCreateModal = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const virement = useAppSelector(state => state.virement.entity);
  const [walletBalances, setWalletBalances] = useState<Pick<DashboardData, 'soldeOmKoriSchool' | 'soldeWaveKoriSchool'> | null>(null);
  const [walletBalancesLoading, setWalletBalancesLoading] = useState(true);
  const [walletBalancesError, setWalletBalancesError] = useState(false);
  const token = Storage.local.get('jhi-authenticationToken') || Storage.session.get('jhi-authenticationToken');
  const getDashboard = () => {
    if (token) {
      axios
        .get<DashboardData>('/api/finance/dashboard/admin', {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        })
        .then(response => {
          setWalletBalances({
            soldeOmKoriSchool: response.data.soldeOmKoriSchool,
            soldeWaveKoriSchool: response.data.soldeWaveKoriSchool,
          });
        })
        .catch(() => setWalletBalancesError(true))
        .then(() => setWalletBalancesLoading(false));
    } else {
      setWalletBalancesError(true);
      setWalletBalancesLoading(false);
    }
  };

  useEffect(() => {
    getDashboard();
    dispatch(getVirement(props.match.params.id));
  }, [props.match.params.id]);

  const handleClose = event => {
    event.stopPropagation();
    props.history.push('/virements');
  };

  const saveEntity = values => {
    const entity = {
      ...virement,
      ...values,
    };
    dispatch(valideVirement(entity));
    handleClose(event);
  };

  const goBack = () => {
    handleClose(event);
  };

  return (
    <>
      <Modal title="Validation de la demande de Virement" centered footer={null} visible={true} closable={false}>
        <h4 className="p-3">
          Montant à Virer: <CountUp end={virement.montant} separator="." /> F CFA
        </h4>
        {walletBalancesError && (
          <Alert
            type="error"
            showIcon
            message="Impossible de récupérer les soldes Wave et OMoney. Réessayez avant de valider ce virement."
            className="mb-3"
          />
        )}
        <Form
          labelCol={{ span: 8 }}
          onFinish={saveEntity}
          wrapperCol={{ span: 18 }}
          initialValues={virement}
          layout="horizontal"
          size="large"
        >
          <Form.Item
            label="OrangeMoney"
            name="omMontant"
            rules={[
              {
                type: 'number',
                min: 0,
                max: walletBalances?.soldeOmKoriSchool ?? 0,
                message: 'Solde insuffisant. Votre solde OMoney est ' + (walletBalances?.soldeOmKoriSchool ?? 0) + ' F',
              },
              { required: true, message: 'Indiquez la somme à virer svp' },
            ]}
          >
            <InputNumber
              className="form-control"
              type="text"
              name="Name"
              min={0}
              style={{ width: 200 }}
              controls={false}
              disabled={walletBalancesLoading || walletBalancesError || !walletBalances}
            />
          </Form.Item>
          <Form.Item
            label="Wave"
            name="waveMontant"
            rules={[
              {
                type: 'number',
                min: 0,
                max: walletBalances?.soldeWaveKoriSchool ?? 0,
                message: 'Solde insuffisant. Votre solde wave est ' + (walletBalances?.soldeWaveKoriSchool ?? 0) + ' F',
              },
              { required: true, message: 'Indiquez la somme à virer svp' },
            ]}
          >
            <InputNumber
              className="form-control"
              type="text"
              name="Name"
              min={0}
              style={{ width: 200 }}
              controls={false}
              disabled={walletBalancesLoading || walletBalancesError || !walletBalances}
            />
          </Form.Item>

          <Form.Item>
            <Button
              style={{ backgroundColor: '#F28E19', color: 'white' }}
              data-cy="entityCreateSaveButton"
              htmlType="submit"
              id="save-entity"
              loading={walletBalancesLoading}
              disabled={walletBalancesLoading || walletBalancesError || !walletBalances}
            >
              <FontAwesomeIcon icon="save" />
              &nbsp; Enregistrer
            </Button>
            &nbsp;
            <Button key="back" type="primary" style={{ color: 'white' }} onClick={goBack}>
              Annuler
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default VirementCreateModal;
